<!--
 * @Description: 
 * @Date: 2022-07-14 16:26:47
-->
<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script lang="ts" setup>
import { withDefaults, defineProps, computed } from 'vue';
interface Props {
  iconClass: string;
  className?: string;
}
const props = withDefaults(defineProps<Props>(), {});
const iconName = computed(() => {
  return `#icon-${props.iconClass}`;
});
const svgClass = computed(() => {
  if (props.className) {
    return 'svg-icon ' + props.className;
  } else {
    return 'svg-icon';
  }
});
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}
</style>
